import { InstallPackageFileCategory, ProgramType } from 'types';

import { ReviewPackageType, reviewPhotoSections } from '../../types/ReviewPackage';
import FormSection from '../Forms/FormSection';
import { InstallPhotosDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';
import { PhotosList } from '../MilestonePackagePartials/Documents/PhotosList';

type InstallPhotosProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: InstallPackageFileCategory[];
  programType: ProgramType;
  isPackageEditable?: boolean;
};

export const InstallPhotos = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  programType,
  isPackageEditable = true,
}: InstallPhotosProps) => {
  return (
    <FormSection description={InstallPhotosDescription} title="Install Photo Documentation">
      {Object.values(reviewPhotoSections).map((section) => {
        if (section.reviewPackageType === ReviewPackageType.installation) {
          return (
            <PhotosList
              key={section.id}
              documentationUrl={section.documentationUrl}
              category={section.id}
              description={section.description}
              title={section.title}
              baseCategory={'Install Photo Documentation'}
              allowArchive={allowArchive}
              flagType={section.type}
              showCheckboxes={showCheckboxes}
              checkboxCategories={checkboxCategories}
              programType={programType}
              isPackageEditable={isPackageEditable}
            />
          );
        }
        return null;
      })}
    </FormSection>
  );
};
